<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">   

	        <el-form size="small">
              
              <!-- 活动基本信息设置 -->      
              <div class="backborder3">
                  <el-col :span="24" class="activetitle">活动基本信息</el-col>
                  <el-col :span="24">
                      <el-col :span="12">
                          <el-form-item label="活动名称">
                              <el-input type="text" v-model="addquery.name" style="width:80%"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="1"></el-col>
                      <el-col :span="10">
                          <el-form-item label="活动时间">
                              <el-date-picker v-model="addquery.date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :unlink-panels="false" style="width:80%"></el-date-picker>
                          </el-form-item>
                      </el-col>
                  </el-col>
                  <el-col :span="24">
                      <el-form-item label="活动规则">
                          <el-input type="textarea" :rows="4" v-model="addquery.value" style="width:83%"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="8">
                      <el-form-item label="请设置活动抽奖次数是否可以累加">                          
                          <el-radio-group v-model="addquery.isadd">
                              <el-radio label="0">否</el-radio>
                              <el-radio label="1">是</el-radio>
                          </el-radio-group>
                      </el-form-item>
                  </el-col>
                  <el-col :span="8">
                      <el-tag type="danger">注：开关开启后，如设置一次活动需要达到的抽奖金额为100元时，客户下单金额/一次抽奖金额所得的商数就是允许抽奖的次数</el-tag>
                  </el-col>
                  <el-col :span="24">
                      <el-form-item label="设置一次活动需要达到的抽奖金额">
                          <el-input v-model="addquery.amount" style="width:15%"><template slot="append">元</template></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="24">
                      <el-form-item label="设置一次活动能设置的最大奖个数">
                          <el-input v-model="addquery.limit" style="width:10%"><template slot="append">个</template></el-input>
                      </el-form-item>
                  </el-col>
      	      </div> 

              <!-- 奖品设置 -->
              <div class="backborder3" style="margin-top:10px;margin-bottom:2rem">
                  <el-col :span="24" class="activetitle">
                      奖品设置<el-button type="danger" icon="el-icon-plus" circle size="mini" style="float:right" @click="adddraws"></el-button>
                  </el-col>

                  <el-table :data="addquery.lists">
                      <el-table-column label="奖品图片" width="180">
                          <template slot-scope="scope">
                              <img :src="scope.row.showimg" v-if="scope.row.showimg!=''" style="width:80%;border-radius:5px;"/>
                              <img src="../../assets/default_img.png" style="width:80%;border-radius:5px;" v-if="scope.row.showimg=='' || scope.row.showimg==null">
                          </template>
                      </el-table-column>
	      	            <el-table-column prop="name" label="奖品名称"></el-table-column> 
                      <el-table-column prop="typename" label="奖品类型"></el-table-column>
                      <el-table-column prop="numbers" label="抽中次数" align="center"></el-table-column>
                      <el-table-column prop="percent" label="抽中概率（100%）" align="center"></el-table-column>
                      <el-table-column prop="sort" label="排序" align="center" style="width:15%">
                          <template slot-scope="scope">
                              <el-input v-model="scope.row.sort" style="width:30%"></el-input>
                          </template>
                      </el-table-column>
                      <el-table-column label="操作" align="center" width="150">
                          <template slot-scope="scope">
                              <el-button type="warning" size="small" icon="el-icon-edit" circle @click="editCurrent(scope.row,scope.$index)"></el-button>
                              <el-button type="danger" size="small" icon="el-icon-delete" circle @click="delCurrent(scope.$index)"></el-button>
                          </template>
                      </el-table-column>
	                </el-table>
                  <el-col :span="24" style="margin-top:20px;margin-bottom:20px;text-align:right;">
      	  	  	      <el-button size="small" type="primary" @click="createadSave">保 存</el-button>
      	  	      </el-col> 
              </div>                                        
          </el-form>
      
          <!-- 新增奖品 -->
          <el-dialog title="新增奖品" :visible.sync="addDialog" width="25%" top="3vh">
                <el-form size="small" style="background:rgb(221,221,221,.3);padding:1rem 0 1rem 5%;border-radius:5px">
                    <el-form-item label="奖品图片">
                        <div>
                            <img :src="drawquery.showimg" v-if="drawquery.showimg!=''" style="width:60%;border-radius:5px;"/>
                            <img src="../../assets/default_img.png" style="width:60%;border-radius:5px;" v-if="drawquery.showimg=='' || drawquery.showimg==null">
                            <input type="file" @change="filecreateminiChange($event)" style="position:absolute;width:100%;right:0;height:6rem;filter:alpha(opacity:0);opacity:0;-moz-opacity:0;-khtml-opacity:0"/>
                        </div>
                    </el-form-item>
                    <el-form-item label="奖品名称">
                        <el-input type="text" v-model="drawquery.name" style="width:60%"></el-input>
                    </el-form-item>
                    <el-form-item label="中奖概率">
                        <el-input type="text" v-model="drawquery.percent" style="width:38%"><template slot="append">%</template></el-input>
                    </el-form-item>
                    <el-form-item label="奖品类型">
                        <el-select v-model="drawquery.type" clearable remote  filterable placeholder="请选择奖品类型" style="width:50%" @change="changetype">
                            <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
                        </el-select>   
                    </el-form-item>
                </el-form>
                
                <!-- 代金券奖品 -->
                <div style="background:rgb(221,221,221,.3);padding:1rem 5% 1rem 5%;border-radius:5px;float:left;width:90%;margin-top:10px;margin-bottom:20px" v-if="drawquery.type==3">
                    <div style="float:left;padding:0 0 .3rem 3%;font-size:.9rem;width:97%;border-bottom:1px solid rgb(255,255,255,1)">
                        <i style="float:left;font-style:normal">请选择代金券</i>
                        <el-button type="primary" size="mini" circle icon="el-icon-search" style="float:right" @click="getcouplists"></el-button>
                    </div>
                    <div v-if="drawquery.list[2].couponname!=''" style="float:left;width:70%;margin-left:5%;margin-top:10px;border:1px solid #ddd;border-radius:6px;color:#fff;background:#fb3b48;padding:.2rem 0 .2rem 0">
                        <span style="float:left;margin-left:10%;margin-top:.3rem;font-size:.9rem;color:#fff;width:90%;line-height:1.2rem">{{drawquery.list[2].desc}}</span>
                        <span style="float:left;margin-left:10%;margin-top:.3rem;margin-bottom:.3rem;font-size:.7rem;color:#fff;width:90%;line-height:1.2rem">{{drawquery.list[2].couponname}}</span>
                    </div>
                </div>
                
                <!-- 实体奖品 -->
                <div style="background:rgb(221,221,221,.3);padding:1rem 5% 1rem 5%;border-radius:5px;float:left;width:90%;margin-top:10px;margin-bottom:20px" v-if="drawquery.type==4">
                    <div style="float:left;padding:0 0 .3rem 3%;font-size:.9rem;width:97%;border-bottom:1px solid rgb(255,255,255,1)">
                        <i style="float:left;font-style:normal">请选择实体奖品</i>
                        <el-button type="primary" size="mini" circle icon="el-icon-search" style="float:right" @click="getmallgoods"></el-button>
                    </div>
                    <div style="float:left;width:95%;margin-left:5%;margin-top:10px;border-radius:6px;" v-if="drawquery.list[3].goodsid!=''">
                        <img :src="drawquery.list[3].showthumb" style="float:left;width:35%;border-radius:5px;border:1px solid #ddd" v-if="drawquery.list[3].showthumb!=''"/>
                        <img src="../../assets/default_img.png" style="float:left;width:35%;border-radius:5px;border:1px solid #ddd" v-if="drawquery.list[3].showthumb==''"/>
                        <span style="float:left;width:58%;margin-left:5%;line-height:1.5rem;font-size:.7rem">{{drawquery.list[3].goodsname}}}</span>
                    </div>
                </div>

                <!-- 红包奖品 -->
                <div style="background:rgb(221,221,221,.3);padding:1rem 5% 1rem 5%;border-radius:5px;float:left;width:90%;margin-top:10px;margin-bottom:20px" v-if="drawquery.type==5">
                    <div style="float:left;padding:0 0 .3rem 3%;font-size:.9rem;width:97%;border-bottom:1px solid rgb(255,255,255,1)">
                        <i style="float:left;font-style:normal">请输入获取红包的金额范围</i>
                    </div>
                    <div style="float:left;width:95%;margin-left:5%;margin-top:10px;border-radius:6px;">
                        <el-input type="text" v-model="drawquery.list[4].min" style="width:40%" placeholder="最小金额"></el-input> ~ 
                        <el-input type="text" v-model="drawquery.list[4].max" style="width:40%" placeholder="最大金额"></el-input>
                    </div>
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button size="medium" @click="addDialog = false">取 消</el-button>
                    <el-button size="medium" type="primary" @click="createdraw">保 存</el-button>
                </div>
          </el-dialog>


          <!-- 获取代金券列表信息 -->
          <el-dialog title="获取代金券信息" :visible.sync="counpDialog" width="55%" top="5vh">
                <el-form size="small">
                    <el-form-item style="width:30%">
                        <el-input type="text" v-model="counpquery.key" clearable placeholder="请输入优惠券活动名称" @change="iscounpchange=true" @input="couplists"></el-input>
                    </el-form-item>
                </el-form>

                <el-tag type="danger" style="margin-top:10px;margin-bottom:10px">温馨提示：此处所选择的代金券类型为自动发放的代金券</el-tag>

                <el-table :data="counplists" v-loading="counpLoading">    	  
                    <el-table-column prop="discribe" label="商品名称"></el-table-column>         
                    <el-table-column label="操作" align="center" width="90">
                        <template slot-scope="scope">
                            <el-button type="success" size="mini" icon="el-icon-check" circle @click="ensureCurrent(scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <!--分页begin-->
                    <el-pagination
                        @size-change="couponpageSizeChange"
                        @current-change="couponpageCurrentChange"
                        :current-page="counpquery.p"
                        :page-sizes="[10, 20, 50]"
                        :page-size="counpquery.rollpage"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="counprow">
                    </el-pagination>
                    <!--分页end-->
                </div>
          </el-dialog>

          <!-- 获取线上商品列表信息 -->
          <el-dialog title="获取线上商品信息" :visible.sync="goodsDialog" width="65%" top="5vh">
                <el-form size="small" :inline="true" class="demo-form-inline" style="width:100%">
                    <!--
                    <el-form-item style="width:15%" v-if="isjdshow==true">
                        <el-select v-model="goodsquery.datafrom" filterable clearable @change="changedatafrom">
                            <el-option v-for="(item,index) in datafrom" :label="item.name" :value="item.id" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    -->
                    <el-form-item style="width:20%">
                        <el-select v-model="goodsquery.brandid" clearable remote  filterable placeholder="按品牌" @change="changegoodsbrand">	            
                            <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                                <span style="float: left">{{item.name}}</span>
                                <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                            </el-option>              
                        </el-select>          
                    </el-form-item>
                    <el-form-item style="width:25%">
                        <el-input placeholder="请输入关键字" v-model="goodsquery.key" clearable @change="changegoodskey" @input="getgoodslists"></el-input>
                    </el-form-item>
                </el-form>
                <el-table :data="goodslists" v-loading="goodsLoading">    	  
                    <el-table-column label="商品名称">
                        <template slot-scope="scope">
                            <div>
                                <img :src="scope.row.showthumb" v-if="scope.row.showthumb!=''" style="float:left;width:30%;border-radius:5px;"/>
                                <img src="../../assets/default_img.png" style="float:left;width:30%;border-radius:5px;" v-if="scope.row.showthumb=='' || scope.row.showthumb==null">
                                <span style="float:left;margin-left:3%;width:67%">{{scope.row.name}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="id" label="编号" width="65"></el-table-column>
                    <el-table-column prop="brandname" label="品牌" width="110"></el-table-column>
                    <el-table-column prop="type" label="来源" width="100" v-if="isjdshow==true"></el-table-column>
                    <el-table-column prop="spec" label="规格" width="90"></el-table-column>
                    <el-table-column label="批发价" width="100">
                        <template slot-scope="scope">
                            <span>{{scope.row.showsellprice}}</span>
                            <span v-if="scope.row.type=='京东'" style="float:left;width:100%;color:red"><i style="position:absolute;padding:.2rem .4rem;background:#f9d040;color:#8b572a;border-radius:5px;font-style:normal;line-height:.5rem;margin:.3rem 0 0 -1.8rem;font-size:.1rem">协</i>{{scope.row.jdcostprice}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button type="success" size="mini" icon="el-icon-check" circle @click="ensuregoods(scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <!--分页begin-->
                    <el-pagination
                        @size-change="goodspageSizeChange"
                        @current-change="goodspageCurrentChange"
                        :current-page="goodsquery.p"
                        :page-sizes="[10, 20, 50]"
                        :page-size="goodsquery.rollpage"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="goodsrow">
                    </el-pagination>
                    <!--分页end-->
                </div>
          </el-dialog>

          
  </div>
  </transition> 
</template>

<script>

export default {
  props:['childdata'],
  data () {
    return {
      url:this.GLOBAL.domain+"Draws/index",
      transitionshow:true,
      addquery: {
         act:'savedraws',
         token:this.$cookies.get('token'),
         id:'',
         name:'',
         date:[],
         amount:'',
         limit:8,
         value:'',
         isadd:'0',
         lists:[],
      },

      addDialog:false,
      typelists:[
          {id:1,name:'谢谢惠顾'},
          {id:2,name:'再来一次'},
          {id:3,name:'优惠券'},
          {id:4,name:'实体奖品'},
          {id:5,name:'现金红包'}
      ],
      drawquery: {
          id:'',
          name:'',
          img:'',
          showimg:'',
          type:'',
          typename:'',
          percent:'',
          numbers:'',
          list:[
            {},
            {},
            {couponid:'',couponname:'',desc:''},
            {goodsid:'',goodsname:'',goodsnum:'',thumb:'',showthumb:''},
            {min:'',max:''},
          ],
      },

      counpquery: {
          act:'counplists',
          token:this.$cookies.get('token'),
          key:'',
          p:1,
          rollpage:10
      },
      counpDialog:false,
      counpLoading:false,
      iscounpchange:false,
      counplists:[],
      counprow:0,

      goodsquery: {
          act:'goodslists',
          token:this.$cookies.get('token'),
          datafrom:1,
          brandid:'',
          key:'',
          p:1,
          rollpage:10
      },
      goodsDialog:false,
      goodsLoading:false,
      isgoodschange:false,
      goodslists:[],
      goodsrow:0,
      datafrom:[{id:1,name:'宠赞'},{id:2,name:'京东'}],
      isjdshow:false,
      brandquery: {
	  	  act:'lists',
          token:this.$cookies.get('token'),
          jdshow:0,
          rollpage:100000
	  },
      brandlists:[],
      addtype:'create',
      updateindex:'',
      
    }  
  },
  mounted(){
     var item=this.childdata;
     this.addquery.id=item.id;
     this.getJDshow(); //查询是否开启调用京东数据权限
     this.getdrawsinfo(); //获取活动信息
  },
  methods:{
    
    /** 获取活动信息 **/
    getdrawsinfo() {
        var resource = this.$resource(this.url);
	      resource.query({act:'getdrawsinfo',id:this.addquery.id,token:this.$cookies.get('token')}).then((res) => {
		      if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
		      }else{
		          var result = JSON.parse(Base64.decode(res.data.Data));
              var _this=this;
              result.lists.forEach(function(item,i) {
                  result.lists[i].type=Number(item.type);
              });

              this.addquery.name=result.name;
              this.addquery.date=result.date;
              this.addquery.amount=result.amount;
              this.addquery.limit=result.limit;
              this.addquery.value=result.value;
              this.addquery.isadd=result.isadd;
              this.addquery.lists=result.lists;
		      }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	      });
    },

    /** 查询是否开启调用京东商品数据权限 **/
	  getJDshow() {
		    var resource = this.$resource(this.GLOBAL.domain+"Goods/index");
	      resource.query({act:'getJDshow',token:this.$cookies.get('token')}).then((res) => {
		      if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
		      }else{
		          var result = JSON.parse(Base64.decode(res.data.Data));
		          this.isjdshow=result.show;
		          if(result.show==0) this.getBrand(0);
		          if(result.show==1) this.getBrand(3);
		      }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	      });
	  },

       /** 获取品牌 **/
	  getBrand(isshow){
	      var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
	      resource.query(this.brandquery).then((res) => {
			  if(res.data.Result>0){
			      if(res.data.Result=='70001') this.$router.push('/login')
			      this.$message.error(res.data.Message);
			  }else{
			      this.brandlists = JSON.parse(Base64.decode(res.data.Data));
			  }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	      });
	  },

      
      //新增活动奖品
      adddraws() {
          if(this.addquery.limit < this.addquery.lists.length) {this.$message.error("奖品个数超过设置一次活动能设置最大奖个数，不能再添加奖品");return false;}
          if(this.addquery.limit == this.addquery.lists.length) {this.$message.error("奖品个数等于设置一次活动能设置最大奖个数，不能再添加奖品");return false;}
          
          this.drawquery.id='';
          this.drawquery.name='';
          this.drawquery.img='';
          this.drawquery.showimg='';
          this.drawquery.type='';
          this.drawquery.typename='';
          this.drawquery.percent='';
          this.drawquery.numbers=0;
          this.drawquery.list=[];
          this.drawquery.list.push({});
          this.drawquery.list.push({});
          this.drawquery.list.push({couponid:'',couponname:'',desc:''});
          this.drawquery.list.push({goodsid:'',goodsname:'',goodsnum:'',thumb:'',showthumb:''});
          this.drawquery.list.push({min:'',max:''});
          this.updateindex='';
          this.addtype='create';
          this.addDialog=true;
      },

      //编辑活动奖品信息
      editCurrent(item,index) {
          this.updateindex=index;
          this.drawquery.id=item.id;
          this.drawquery.name=item.name;
          this.drawquery.img=item.showimg;
          this.drawquery.showimg=item.showimg;
          this.drawquery.type=item.type;
          this.drawquery.typename=item.typename;
          this.drawquery.numbers=item.numbers;
          this.drawquery.percent=item.percent;
          this.drawquery.list=[];
          this.drawquery.list.push({});
          this.drawquery.list.push({});
          item.type==3 ? this.drawquery.list.push(item.data) : this.drawquery.list.push({couponid:'',couponname:'',desc:''});
          item.type==4 ? this.drawquery.list.push(item.data) : this.drawquery.list.push({goodsid:'',goodsname:'',goodsnum:'',thumb:'',showthumb:''});
          item.type==5 ? this.drawquery.list.push(item.data) : this.drawquery.list.push({min:'',max:''});
          this.addtype='update';
          this.addDialog=true;
      },

      //确认选择代金券信息
      ensureCurrent(item) {
          this.drawquery.list[2].couponid=item.id;
          this.drawquery.list[2].couponname=item.name;
          this.drawquery.list[2].desc=item.discribe;
          this.counpDialog=false;
      },

      //获取优惠券信息
      getcouplists() {
          this.counpquery.key='';
          this.counpquery.p=1;
          this.counpquery.rollpage=10;
          this.counpDialog=true;
          this.couplists();
      },
      //优惠券信息列表
      couplists() {
          if(this.iscounpchange==true) {
              this.counpquery.p=1;
              this.counpquery.rollpage=10;
          }
          
          this.counplists=[];
          this.counpLoading=true;
    	  var resource = this.$resource(this.url);
          resource.query(this.counpquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.counpLoading=false;
	        }else{
	        	var _this=this;
	            this.counplists = JSON.parse(Base64.decode(res.data.Data));
	            this.counprow=parseInt(res.data.count);
	            this.counpLoading=false;
                if(this.iscounpchange==true) this.iscounpchange=false;
	        }
          }).catch((res) => {
              this.counpLoading=false;
          });
      },

      couponpageSizeChange(val) {
        this.counpquery.rollpage = val;
        this.couplists();
      },
      couponpageCurrentChange(val) {
        this.counpquery.p = val;
        this.couplists();
      },

      //确认选择商品信息
      ensuregoods(item) {
          this.drawquery.list[3].goodsid=item.id;
          this.drawquery.list[3].goodsname=item.name;
          this.drawquery.list[3].goodsnum=1;
          this.drawquery.list[3].thumb=item.thumb;
          this.drawquery.list[3].showthumb=item.showthumb;
          this.goodsDialog=false;
      },

      //获取线上商城商品信息
      getmallgoods() {
          this.goodsquery.datafrom='';
          this.goodsquery.brandid='';
          this.goodsquery.key='';
          this.goodsquery.p=1;
          this.goodsquery.rollpage=10;
          this.goodsDialog=true;
          this.getgoodslists();
      },

      //获取商品列表信息
      getgoodslists() {
          if(this.isgoodschange==true) {
              this.goodsquery.p=1;
              this.goodsquery.rollpage=10;
          }
          
          this.goodslists=[];
          this.goodsLoading=true;
    	  var resource = this.$resource(this.url);
          resource.query(this.goodsquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.goodsLoading=false;
	        }else{
	        	var _this=this;
	            this.goodslists = JSON.parse(Base64.decode(res.data.Data));
	            this.goodsrow=parseInt(res.data.count);
	            this.goodsLoading=false;
                if(this.isgoodschange==true) this.isgoodschange=false;
                
                var _this=this;
                this.goodslists.forEach(function(item,i) {
                    if(item.thumb!='' && item.type=='宠赞') _this.goodslists[i].showthumb=_this.GLOBAL.staticUrl+item.thumb
                    if(item.thumb!='' && item.type=='京东') _this.goodslists[i].showthumb='http://img13.360buyimg.com/n1/'+item.thumb
                });
	        }
          }).catch((res) => {
              this.goodsLoading=false;
          });
      },
      
      changedatafrom() {
          this.isgoodschange=true;
          this.getgoodslists();
      },
      changegoodsbrand() {
          this.isgoodschange=true;
          this.getgoodslists();
      },
      changegoodskey() {
          this.isgoodschange=true;
          this.getgoodslists();
      },
      goodspageSizeChange(val) {
          this.goodsquery.rollpage = val;
          this.getgoodslists();
      },
      goodspageCurrentChange(val) {
            this.goodsquery.p = val;
            this.getgoodslists();
      },

      //上传奖品图
      filecreateminiChange(el) {
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	var formData = new FormData();
    	formData.append('file', el.target.files[0]);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
	        if(data.Result > 0) {
	            this.$message.error(data.msg);
	        }else {
	        	this.drawquery.showimg=this.GLOBAL.staticUrl+data.imgsrc;
	            this.drawquery.img=data.imgsrc;
			    el.target.value = '';  
	        }
	     }).catch((res) => {
	        	
	     });
      },

      //修改奖品类型
      changetype() {
          var _this=this;
          this.drawquery.typename='';
          this.typelists.forEach(function(item,i) {
              if(_this.drawquery.type==item.id) _this.drawquery.typename=item.name;
          });
      },

      //保存添加的奖品信息
      createdraw() {
          if(this.drawquery.img=='') {this.$message.error("请上传奖品图片");return false;}
          if(this.drawquery.name=='') {this.$message.error("请填写奖品名称");return false;}
          if(this.drawquery.percent=='') {this.$message.error("请填写中奖概率");return false;}
          if(this.drawquery.type=='') {this.$message.error("请选择奖品类型");return false;}
          if(this.drawquery.type==3 && this.drawquery.list[2].couponid=='') {this.$message.error("请选择代金券");return false;}
          if(this.drawquery.type==4 && this.drawquery.list[3].goodsid=='') {this.$message.error("请选择实体奖品");return false;}
          if(this.drawquery.type==5 && this.drawquery.list[4].min=='') {this.$message.error("请输入最小金额");return false;}
          if(this.drawquery.type==5 && this.drawquery.list[4].max=='') {this.$message.error("请输入最大金额");return false;}
          if(this.drawquery.type==5 && this.drawquery.list[4].min < 0) {this.$message.error("最小金额必须大于等于0");return false;}
          if(this.drawquery.type==5 && this.drawquery.list[4].max < 0) {this.$message.error("最大金额必须大于等于0");return false;}
          //if(this.drawquery.type==5 && this.drawquery.list[4].min >= this.drawquery.list[4].max) {this.$message.error("最小金额不能大于等于最大金额");return false;}
          var nums=this.updateindex;

          //新增
          if(this.addtype=='create' && this.drawquery.type==1) this.addquery.lists.push({id:'',showimg:this.drawquery.showimg,name:this.drawquery.name,type:this.drawquery.type,typename:this.drawquery.typename,numbers:0,percent:this.drawquery.percent,sort:0,data:this.drawquery.list[0]});
          if(this.addtype=='create' && this.drawquery.type==2) this.addquery.lists.push({id:'',showimg:this.drawquery.showimg,name:this.drawquery.name,type:this.drawquery.type,typename:this.drawquery.typename,numbers:0,percent:this.drawquery.percent,sort:0,data:this.drawquery.list[1]});
          if(this.addtype=='create' && this.drawquery.type==3) this.addquery.lists.push({id:'',showimg:this.drawquery.showimg,name:this.drawquery.name,type:this.drawquery.type,typename:this.drawquery.typename,numbers:0,percent:this.drawquery.percent,sort:0,data:this.drawquery.list[2]});
          if(this.addtype=='create' && this.drawquery.type==4) this.addquery.lists.push({id:'',showimg:this.drawquery.showimg,name:this.drawquery.name,type:this.drawquery.type,typename:this.drawquery.typename,numbers:0,percent:this.drawquery.percent,sort:0,data:this.drawquery.list[3]});
          if(this.addtype=='create' && this.drawquery.type==5) this.addquery.lists.push({id:'',showimg:this.drawquery.showimg,name:this.drawquery.name,type:this.drawquery.type,typename:this.drawquery.typename,numbers:0,percent:this.drawquery.percent,sort:0,data:this.drawquery.list[4]});

          //编辑
          if(this.addtype=='update') {
              this.addquery.lists[nums].id=this.drawquery.id;
              this.addquery.lists[nums].showimg=this.drawquery.showimg;
              this.addquery.lists[nums].name=this.drawquery.name;
              this.addquery.lists[nums].type=this.drawquery.type;
              this.addquery.lists[nums].typename=this.drawquery.typename;
              this.addquery.lists[nums].numbers=this.drawquery.numbers;
              this.addquery.lists[nums].percent=this.drawquery.percent;
              this.drawquery.type==1 ? this.addquery.lists[nums].data=this.drawquery.list[0] : '';
              this.drawquery.type==2 ? this.addquery.lists[nums].data=this.drawquery.list[1] : '';
              this.drawquery.type==3 ? this.addquery.lists[nums].data=this.drawquery.list[2] : '';
              this.drawquery.type==4 ? this.addquery.lists[nums].data=this.drawquery.list[3] : '';
              this.drawquery.type==5 ? this.addquery.lists[nums].data=this.drawquery.list[4] : '';

          }
          this.addDialog=false;
      },

      //删除奖品信息
      delCurrent(index) {
          this.addquery.lists.splice(index,1);
      },

      //保存抽奖活动信息
      createadSave() {
          var resource = this.$resource(this.url);
          resource.save(this.addquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	        	    this.$message.success("抽奖活动信息修改成功");
                this.$emit('closechild','Drawsedit'); //关闭窗口
	        }
          }).catch((res) => {
              
          });
      },


  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.backborder3 {background:#fff;border:1px solid #ddd;float:left;width:98%;padding:1% 1% 0 1%;border-radius:5px}
.el-radio__input.is-checked .el-radio__inner {border-color:#E6A23C;background:#E6A23C}
.el-radio__input.is-checked+.el-radio__label {color:#E6A23C;}
.activetitle {color:#606266;font-size:.9rem;line-height:1.5rem;padding:0 0 .5rem 0;border-bottom:1px solid rgb(220,223,230,.7);margin-bottom:2rem}
</style>


// WEBPACK FOOTER //
// src/components/mall/Drawsedit.vue